import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { RootLifecycleEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { globalSettingsIssuesWorkflowsSchemesEditRoute } from '@jira/router-routes__legacy-global-settings-issues-workflows-schemes-edit-routes/src/globalSettingsIssuesWorkflowsSchemesEditRoute.tsx';
import { ProjectSettingsWorkflowsSchemesEdit } from './ProjectSettingsWorkflowsSchemesEdit.tsx';

const globalSettingsIssuesWorkflowsSchemesEditMigrationEmptyProps = {};
const globalSettingsIssuesWorkflowsSchemesEditMigrationEntryPoint0 = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-globalSettingsIssuesWorkflowsSchemesEdit-0" */ './GlobalSettingsIssuesWorkflowsSchemesEditRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => globalSettingsIssuesWorkflowsSchemesEditMigrationEmptyProps,
	},
});

export const globalSettingsIssuesWorkflowsSchemesEditRouteEntry: LegacyEntryRoute<RouteResources> =
	createLegacyEntry(globalSettingsIssuesWorkflowsSchemesEditRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		resources: [navigationSidebarGlobalResource],

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_9')
			? undefined
			: ProjectSettingsWorkflowsSchemesEdit,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_9')
				? globalSettingsIssuesWorkflowsSchemesEditMigrationEntryPoint0
				: undefined,
		entryPointContainer: fg('nike_entrypoint_migration_batch_9')
			? RootLifecycleEntryPointContainer
			: undefined,
	}));
